import { MaintenanceWindowSimpleSchedulerWebComponent } from './component/MaintenanceWindowSimpleSchedulerWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_SIMPLE_SCHEDULER } from '../../webcomponents.constants';

export { MaintenanceWindowSimpleSchedulerWebComponent };

window.customElements.define(
  WEB_COMPONENT_MAINTENANCE_WINDOW_SIMPLE_SCHEDULER,
  MaintenanceWindowSimpleSchedulerWebComponent
);
